import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import clsx from 'clsx'
import { SectionTitle } from 'chaoskit/src/components'

import SlackSignUpForm from '~partials/slack/SlackSignUpForm'
import { ReactComponent as SlackSymbolSVG } from '~media/logos/slack-symbol.svg'
import { slantBackground } from '~styles/utility'

const INTRO_TYPES = {
  tutorial: 'Get your questions answered in the #support channel.',
  blog:
    'Connect with 5,000+ engineers who are building more reliable systems with Chaos Engineering.',
}

const SlackSignUpEmbed = ({
  type = 'tutorial',
  className,
  contrast,
  formProps,
}) => {
  const theme = useTheme()

  return (
    <div
      css={{
        [theme.mq.medium]: {
          display: 'grid',
          gridTemplateColumns: '0.5fr',
          justifyContent: 'center',
        },
      }}
      className={clsx(className, {
        [theme.settings.classes.contrast]: contrast,
      })}
    >
      <div
        css={[
          {
            boxShadow: theme.boxShadow.large,
            padding: theme.space.base,
            borderRadius: theme.borderRadius.large,

            [theme.mq.medium]: {
              padding: theme.space.large,
            },
          },

          !contrast && {
            border: theme.border.base,
          },

          contrast && [slantBackground(theme)],
        ]}
      >
        <SlackSymbolSVG
          style={{ height: 60 }}
          css={{
            display: 'block',
            marginBottom: theme.space.base,

            [theme.mq.small__max]: {
              marginLeft: 'auto',
              marginRight: 'auto',
            },
          }}
        />
        <SectionTitle
          align={{ medium: 'left' }}
          title="Join the Chaos Engineering Slack"
          sub={INTRO_TYPES[type]}
          css={{ marginBottom: `${theme.space.large}px !important` }}
        />
        <SlackSignUpForm {...formProps} />
      </div>
    </div>
  )
}

SlackSignUpEmbed.propTypes = {
  type: PropTypes.oneOf(['blog', 'tutorial']),
  contrast: PropTypes.bool,
  className: PropTypes.string,
  formProps: PropTypes.object,
}

export default SlackSignUpEmbed
